

import {gql} from "apollo-angular";

const UPDATE_NOTIFICATIONS = gql`
mutation UpdateNotifications($id: ID!, $isActive: Boolean) {
  updateNotifications(id: $id, isActive: $isActive) {
    errors
    success
    notifications {
      id
    }
  }
}
`

export {UPDATE_NOTIFICATIONS}
